import React, { forwardRef } from 'react';

import { Stack } from 'Modules/ui3';

import { EmissionTypography } from '../Cells';
import { CellContainer } from '../CellContainer';
import { CellProps, RowProps, WithOnScroll } from '../types';


type HeaderProps = RowProps & Omit<CellProps, 'data' | 'column'> & WithOnScroll;

export const Header = forwardRef<HTMLDivElement, HeaderProps>((
    { columns, t, isDesktop, columnsWidth, onScroll }, ref,
) => (
    <Stack
        ref={ref}
        flex={0}
        direction='row'
        justifyContent='space-between'
        spacing={6}
        pb={isDesktop ? 5 : 4}
        overflow='auto'
        onScroll={onScroll}
        {...isDesktop ? {
            borderBottom: '1px solid',
            borderColor: 'grayscale.shade40',
        } : {}}
        sx={{
            '&::-webkit-scrollbar': {
                height: '8px',
                backgroundColor: 'grayscale.shade20',
                borderRadius: '4px',
                border: '1px solid',
                borderColor: 'grayscale.shade40',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'grayscale.shade60',
                border: '1px solid',
                borderRadius: '20px',
                borderColor: 'grayscale.shade40',
            },
        }}
    >
        {columns.map((column, index) => (
            <CellContainer
                key={column.field}
                columnWidth={columnsWidth[index]}
            >
                <EmissionTypography color='grayscale.shade90'>
                    {t(`columns.${column.field}`)}
                </EmissionTypography>
            </CellContainer>
        ))}
    </Stack>
));
